import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {CostOfProductEntity} from '~local/app/types/CostOfProductEntity';
import {Observable} from 'rxjs';

@Injectable()
export class CostOfProductService {
    constructor(private http: HttpClient) {}

    public loadData(globalFilter: string): Observable<CostOfProductEntity[]> {
        globalFilter = globalFilter || '';
        return this.http.get<CostOfProductEntity[]>(`/admin/profit/cost/${globalFilter}`);
    }

    public updateCostOfProduct(entity: CostOfProductEntity): Observable<any> {
        return this.http.put<any>(`/admin/profit/cost`, entity);
    }
}
